import { UploadResponse } from 'APIPackage/MainModule/types/UploadResponse';

import { apiPost } from '../common/apiTools';

export async function fetchUploadFile(data: FormData): Promise<UploadResponse> {
  return apiPost({ url: '/support/api/feedback/attach', body: data });
}
